export const TRUSTED = 'Trusted';
export const RESTRICTED = 'Restricted';
export const NEW = 'New';

export const DEFAULT_LIMIT_AMT = 25;
